var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import ReactMarkdown from 'react-markdown';
import Headline from '../Headline';
import Image from '../Image';
import { Link } from '../Link';
import List, { ListItem } from '../List';
import { TableAtom as Table, TdAtom as Td, ThAtom as Th, } from '../Table';
import { Em, P, Strong } from '../Text';
import tableTheme from '../Table/theme';
import { ComponentThemeProvider } from '../ThemeProvider';
var LinkRenderer = function (_a) {
    var to = _a.href, props = __rest(_a, ["href"]);
    return React.createElement(Link, __assign({ to: to }, props));
};
var HeadlineRenderer = function (_a) {
    var props = __rest(_a, []);
    return React.createElement(Headline, __assign({}, props));
};
var TableCellRenderer = function (_a) {
    var isHeader = _a.isHeader, props = __rest(_a, ["isHeader"]);
    if (isHeader) {
        return (React.createElement(ComponentThemeProvider, { theme: tableTheme },
            React.createElement(Th, __assign({}, props))));
    }
    return (React.createElement(ComponentThemeProvider, { theme: tableTheme },
        React.createElement(Td, __assign({}, props))));
};
var MarkdownImage = function (props) { return (React.createElement(Image, __assign({}, props, { alt: props.alt || '', src: props.src || '' }))); };
var MarkdownTable = function (props) { return React.createElement(Table, __assign({}, props)); };
var MarkdownListItem = function (props) { return (React.createElement(ListItem, null, props.children)); };
//
// ALL props of markdown renderers must be OPTIONAL.
//
var renderers = {
    paragraph: P,
    emphasis: Em,
    strong: Strong,
    link: LinkRenderer,
    image: MarkdownImage,
    linkReference: LinkRenderer,
    imageReference: MarkdownImage,
    table: MarkdownTable,
    tableCell: TableCellRenderer,
    list: List,
    listItem: MarkdownListItem,
    heading: HeadlineRenderer,
};
export var Markdown = function (_a) {
    var content = _a.content, className = _a.className;
    return (React.createElement(ReactMarkdown, { className: className, renderers: renderers, source: content }));
};
export default Markdown;
//# sourceMappingURL=index.js.map